import React, { useState } from "react";
import styles from "./LocationManagement.module.css";
import HeadingComponent from "../../../../components/HeadingComponent/HeadingComponent";
import { t } from "i18next";
import TopTab from "../../../../components/TopTab/TopTab";
import BasicInfoLocationManagement from "./BasicInfoLocationManagement/BasicInfoLocationManagement";
import BakeryScheduleLocationManagement from "./BakeryScheduleLocationManagement/BakeryScheduleLocationManagement";
import { RiEditBoxLine } from "react-icons/ri";
import { SubmitButton, TextComponent } from "../../../../components";
import { useNavigate } from "react-router-dom";
import TopTabComponent from "../../../../components/TopTabComponent/TopTabComponent";

const LocationManagement = () => {
  const [isScheduleEditable, setisScheduleEditable] = useState(false);
const navigate = useNavigate('');
  const options = [
    { id: 1, name: "Basic Info" },
    { id: 2, name: "Bakery Schedule" },
  ];

  const [focused, setFocused] = useState(options[0]);
  return (
    <div className={styles.mainCont}>
      <div className={styles.HeaderDiv}>
        <TextComponent
         className={styles.Heading}
          fontSize={"var(--dashboard_tabs-font-size)"}
          text={t("Bakery Details")}
        />
        <div className={styles.TopTabListStyle}>
        
           <TopTabComponent
          options={options}
           focused={focused}
            setFocused={setFocused}
         TabStyle={styles.TabStyle}
            TabLabelColor={"--var(--white-color)"}
        />
        </div>  

        {focused?.name === "Bakery Schedule" && (
          <div onClick={() => setisScheduleEditable(!isScheduleEditable)}>
            {!isScheduleEditable ? (
              <RiEditBoxLine color="#09244B" size={18} cursor={"pointer"} />
            ) : (
              <SubmitButton
                onClick={() => setisScheduleEditable(false)}
                title={"Save Changes"}
                btnContainerClass={styles.SavebtnContainer}
                primary
                btnClass={`${styles.Savebtn}`}
              />
            )}
          </div>
        )}

        {focused?.name === "Basic Info" && (
          <RiEditBoxLine color="#09244B" size={18} cursor={"pointer"}  onClick={()=> navigate('/EditBakeryDetail')} />
        )}
      </div>
      {focused?.name === "Basic Info" && <BasicInfoLocationManagement />}
      {focused?.name === "Bakery Schedule" && (
        <BakeryScheduleLocationManagement
          setisScheduleEditable={setisScheduleEditable}
          isScheduleEditable={isScheduleEditable}
        />
      )}
    </div>
  );
};

export default LocationManagement;
